<!-- @author Ravi, @date 19-10-2021, @description Report schedule For Send mail of reports  company popup component-->

<div class="mainContent" style="overflow: hidden; height: 85vh">

  <div style="height: 7vh; padding-left: 2%; display: flex; align-items: center;">
    <!-- Main Header -->
    <label i18n="@@spmsUserReg" [ngClass]="{ 'textColour': !showOnlyButtons }" style="margin-right: 20px;cursor: pointer;font-size: large;font-family: initial;color: #000000;font-weight: 400;"(click)="onHeader1Click()">
      {{ header }}
    </label>
  
    <!-- Conditional Secondary Header -->
    <label *ngIf="data.scheduleFor === 'Dataset Refresh'" i18n="@@spmsUserReg" [ngClass]="{ 'textColour': showOnlyButtons }"
      style="cursor: pointer;font-size: large;font-family: initial;color: #000000;font-weight: 400;" (click)="onHeader2Click()">
      {{ header2 }}
    </label>

  
    <span class="example-spacer"></span>
  </div>
  

  <div *ngIf="!showOnlyButtons" style="height: 70vh;overflow: auto;padding-left: 2%;padding-right: 2%;">

    <form novalidate [formGroup]="FormValid" style="width: 100%;">
      <div class="row" style="margin-top: 35px;">

        <div class="col-lg-8">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMclassifiedserviceType"
            >Time Schedule Description</mat-label
            >
            <input
              matInput
              type="text"
              formControlName="timeScheduleDescription"
              maxlength="107"
              [(ngModel)]="timeScheduleDescription"
              [ngClass]="{'red-text': timeScheduleDescription.includes('null') || timeScheduleDescription.includes('undefined')}"
              readonly
              required
            />
            <mat-error
              *ngFor="
                let validation of validation_messages.reportName
              ">
              <span
                *ngIf="
                  FormValid.get('reportName').hasError(
                    validation.type
                  ) &&
                  (FormValid.get('reportName').dirty ||
                    FormValid.get('reportName').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 10px;">

        <div class="col-lg-3">
          <mat-form-field appearance="outline">

            <mat-label i18n="@@TMSTAFFMASTERLastname">Schedule Date (UTC)</mat-label>
            <input matInput [(ngModel)]="startDatetemp" [min]="currentTimeStamp" (ngModelChange)="onInputChange()" [matDatepicker]="startYear" readonly required
                   formControlName="startYear">

            <mat-datepicker-toggle matSuffix [for]="startYear">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>

            </mat-datepicker-toggle>
            <mat-datepicker #startYear startView="multi-year"
                            panelClass="example-month-picker"
            ></mat-datepicker>
            <mat-error
              *ngIf="FormValid.get('startYear').hasError('matDatepickerParse') && (FormValid.get('startYear').dirty || FormValid.get('startYear').touched)">
              <span>Start Date is required</span>
            </mat-error>
            <mat-error
              *ngIf="FormValid.get('startYear').hasError('required') && (FormValid.get('startYear').dirty || FormValid.get('startYear').touched)">
              <span>Start Date is required</span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMclassifiedserviceType"
            >Time (UTC)</mat-label
            >
            <input
              matInput

              formControlName="scheduletime"
              maxlength="25"
              [(ngModel)]="timestamptemp"
              [owlDateTimeTrigger]="time"
              [owlDateTime]="time"
              (ngModelChange)="onInputChange()"
              required
              readonly

            />
            <em
              [owlDateTimeTrigger]="time"
              class="fas fa-caret-down"
              style="
                  display: flex;
                  position: absolute;
                  top: 20%;
                  left: 93%;
                  font-size: 18px;
              "
            ></em>
            <owl-date-time [pickerType]="'timer'" [hour12Timer] = "true" #time></owl-date-time>

            <mat-error
              *ngFor="
                  let validation of validation_messages.time
                "
            >
                <span
                  *ngIf="
                    FormValid.get('time').hasError(
                      validation.type
                    ) &&
                    (FormValid.get('time').dirty ||
                      FormValid.get('time').touched)
                  "
                >
                  {{ validation.message }}
                </span>
            </mat-error>
          </mat-form-field>
        </div>


        <div class="col-lg-3">
          <mat-form-field appearance="outline">

            <mat-label>Valid Upto (UTC)</mat-label>
            <input matInput [matDatepicker]="dp3"   [(ngModel)]="endDateTemp"   [min]="endDateTemp" (ngModelChange)="onEndDateChange()"

                   formControlName="endYear"readonly >
            <mat-datepicker-toggle matSuffix [for]="dp3">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #dp3   startView="multi-year" panelClass="example-month-picker"></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Select Date Type</mat-label>
             <mat-select   formControlName="date"  (selectionChange)="ChangeSelect($event)"
                        [(ngModel)]="date" >
             
              <mat-option value="daily">Daily</mat-option>
              <mat-option value="weekly">Weekly</mat-option>
              <mat-option value="monthly">Monthly</mat-option>
              <mat-option value="yearly">Yearly</mat-option>
              <mat-option value="minutes">Minutes</mat-option>
              <mat-option value="hourly">Hourly</mat-option>
            </mat-select>
          </mat-form-field>
        </div>


      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg-3"  *ngIf="date != 'daily' && date !='hourly' && date !='minutes'">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">{{dateType}}</mat-label>
            <mat-select  (selectionChange)="timescheduleDescription()" formControlName="scheduledOn"
                        [(ngModel)]="scheduledOn"  multiple >
              <mat-option *ngFor="let option of options" [value]="option.id">{{option.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-3" *ngIf="date=='yearly'">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Select Year</mat-label>
             <mat-select  (selectionChange)="timescheduleDescription()" [(ngModel)]="years" formControlName="year" multiple>
              <mat-option *ngFor="let year of yearsDropDown" [value]="year.id">
                {{ year.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-3" *ngIf="date=='yearly'">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Select months</mat-label>
           <mat-select  (selectionChange)="timescheduleDescription()" [(ngModel)]="months" formControlName="month" multiple>
            <mat-option *ngFor="let month of monthsDropDown" [value]="month.id">
              {{ month.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
          </div>
        <div class="col-lg-3" *ngIf="date=='monthly'">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Select months</mat-label>
             <mat-select  (selectionChange)="timescheduleDescription()" [(ngModel)]="monthType" formControlName="monthType">
              <mat-option *ngFor="let month of monthTypeDropDown" [value]="month.id">
                {{ month.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Alternative Recurrence</mat-label>
             <mat-select  (selectionChange)="timescheduleDescription()" formControlName="alternativeRecurrence"
                        [(ngModel)]="alternativeRecurrence">
              <mat-option *ngFor="let alternativeRecurrence of alternativeRecurrences" [value]="alternativeRecurrence">{{alternativeRecurrence}}</mat-option>

            </mat-select>
          </mat-form-field>
        </div>


      </div>

    </form>

    <div style="height:1vh">
      <div
        class="row"
        style="position: sticky; left: 0; bottom: 0; width: 100%"
      >

        <div class="col-lg text-center">

          <div style="text-align: end;">

            <button i18n="@@TargetClear" type="button" (click)="updateData()"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">{{btnName}}</button>

            <button i18n="@@TargetClear" type="button" (click)="clear()"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Clear</button>

            <button i18n="@@TargetCancel" type="button" (click)="close()"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Cancel</button>


          </div>
        </div>
      </div>

      <div style=" overflow: auto;">
        <div style="margin-top: 1%; width: 100%; ">
          <mat-toolbar
            class="agGridtopersDiv card"
            style="background: rgb(228 227 230 / 41%);
            border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;" >
            <label i18n="@@spmsUserReg" class="gridLabel">Schedulers</label>

            <span class="example-spacer"></span>

            <button
              class="
              popup
              gridColour
              btn btn-rounded-button
              z-depth-1
              waves-effect waves-light
              text-capitalize
            "
              [style.background-color]="backgroundColorButton"
              title="Download"
              (click)="onBtExport()"
            >
              Download
              <em
                style="padding: 0px 0px 0px 10px"
                class="fas fa-download example-icon"
                title="Download"
              ></em>
            </button>
            <div class="insertPageNoDiv">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                <input
                  matInput
                  type="text"
                  (input)="onSearchChange($event.target.value)"
                />
              </mat-form-field>
            </div>
            <div class="selectRecordsDiv" style="width: 9.5%">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label i18n="@@Targetrecords" style="color: black"
                >Records</mat-label
                >
                <mat-select
                  [(ngModel)]="pageSize"
                  (ngModelChange)="onPageSizeChanged()"
                >
                  <mat-option value="10" selected>10</mat-option>
                  <mat-option value="200">200</mat-option>
                  <mat-option value="300">300</mat-option>
                  <mat-option value="400">400</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="
              card
              pagination
              paginationFirstButton
              paginationFirstlastButton
            "
            >
              <em
                class="fas fa-angle-double-left waves-effect waves-light"
                (click)="onBtFirst()"
              ></em>
            </div>
            <div class="card pagination paginationButtons btn-rounded">
              <ul>
                <li class="paginationliicon">
                  <em
                    class="fas fa-angle-left waves-effect waves-light"
                    (click)="onBtPrevious()"
                  ></em>
                </li>
                <li>{{ currentPage }}/{{ totalPages }}</li>
                <li class="paginationliicon" style="padding: 0">
                  <em
                    class="fas fa-angle-right waves-effect waves-light"
                    (click)="onBtNext()"
                  ></em>
                </li>
              </ul>
            </div>
            <div
              class="
              card
              pagination
              paginationLastButton
              paginationFirstlastButton
            "
            >
              <em
                class="fas fa-angle-double-right waves-effect waves-light"
                (click)="onBtLast()"
              ></em>
            </div>
          </mat-toolbar>
        </div>
        <!-- dispatch ag-grid -->
        <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin"
          style="height: 55vh;"
          [columnDefs]="columnDefs"
          [animateRows]="true"
          [pagination]="true"
          [rowSelection]="rowSelection"
          [defaultColDef]="defaultColDef"
          [suppressPaginationPanel]="true"
          [rowHeight]="35"
          [gridOptions]="gridOptions"
          [headerHeight]="35"
          [enableBrowserTooltips]="true"
          [floatingFiltersHeight]="45"
          [paginationPageSize]="paginationPageSize"
          [paginationNumberFormatter]="paginationNumberFormatter"
          [enableRangeSelection]="true"
          [components]="components"
          [debug]="true"
          [rowClassRules]="rowClassRules"
          (paginationChanged)="onPaginationChangedReturn()"
          (gridReady)="onGridReady($event)"
          [hidden]="!true"
          (rowDoubleClicked)="rowDoubleClicked($event)">
        </ag-grid-angular>
      </div>

    </div>
  </div>

  <!-- Buttons fixed to bottom-right inside .mainContent -->
  <div *ngIf="showOnlyButtons" style="position: absolute; bottom: 12%; right: 14%; z-index: 100;">
  
    <button i18n="@@TargetProceed" type="button" (click)="onProceed()"
      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      style="padding: .3rem 1.6rem; font-size: .85rem; width: 120px; color: white; margin-right: 10px;">
      Proceed
    </button>
  
    <button i18n="@@TargetCancel" type="button" (click)="close()"
      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      style="padding: .3rem 1.6rem; font-size: .85rem; width: 95px; color: white;">
      Cancel
    </button>
  </div>
  
  

  
</div>
   